export default {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://qa.api.goandgive.duasparaum.com',
  defaultLocale: process.env.REACT_APP_DEFAULT_LOCALE || "pt"
}